<template>
  <v-menu
    bottom
    left
    min-width="100"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        x-small
        icon
        outlined
        color="primary"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list
      dense
      class="pa-0"
    >
      <v-list-item
        v-if="active"
        @click="inActivate()"
      >
        <v-list-item-title>
          <v-icon
            small
            left
            color="error"
          >
            mdi-lightbulb-off
          </v-icon>
          In-activate
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        v-else
        @click="activate()"
      >
        <v-list-item-title>
          <v-icon
            small
            left
            color="success"
          >
            mdi-lightbulb-on
          </v-icon>
          Activate
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { failure } from "@/mixins/common";
export default {
	name: "RoleOptions",
	mixins: [failure],
	props: {
		roleId: {
			type: Number,
			required: true
		},
		active: {
			type: Boolean,
			required: true
		}
	},
	data() {
		return {};
	},
	methods: {
		inActivate() {
			this.$root.$confirm
				.open("Confirm", "Are you sure you want to inactivate?", {})
				.then((confirm) => {
					if (!confirm) {
						return;
					}
					this.$http
						.put(`${this.ADMIN_API_URL}/roles/${this.roleId}/inactivate`)
						.then(
							function(data) {
								this.handleSuccess(data.body);
							},
							function(failure) {
								this.handleFailure(failure);
							}
						);
				});
		},
		activate() {
			this.$root.$confirm
				.open("Confirm", "Are you sure you want to activate?", {})
				.then((confirm) => {
					if (!confirm) {
						return;
					}
					this.$http
						.put(`${this.ADMIN_API_URL}/roles/${this.roleId}/activate`)
						.then(
							function(data) {
								this.handleSuccess(data.body);
							},
							function(failure) {
								this.handleFailure(failure);
							}
						);
				});
		},
		handleSuccess: function(response) {
			this.$store.commit("showSnackbar", {
				timeout: 3000,
				message: response.message
			});
			this.$emit("reload");
		}
	}
};
</script>
